export enum DeferredRequestKey {
  DeliveryPickup = 'deliveryPickup',
  Discounts = 'discounts',
  Favorites = 'favorites',
  OwnerReviews = 'ownerReviews',
  Pricing = 'pricing',
  Trades = 'trades',
  WhyBuy = 'whyBuy'
}

export const DEFERRED_REQUEST_KEYS = Object.values(DeferredRequestKey);
